import { render } from "./edit-role.vue?vue&type=template&id=6fb03cb7&scoped=true"
import script from "./edit-role.vue?vue&type=script&lang=js"
export * from "./edit-role.vue?vue&type=script&lang=js"

import "./edit-role.vue?vue&type=style&index=0&id=6fb03cb7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb03cb7"]])

export default __exports__